/**
 * @generated SignedSource<<7fec81822460be022fc2ed66a230eef2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AutoRecordRuleFilterOrganizer = "ANYONE" | "SELF";
export type AutoRecordRuleLevel = "GROUP" | "USER" | "WORKSPACE";
export type AutoRecordRuleType = "RECORD" | "RESTRICT";
export type FilterAttendeeType = "EXTERNAL_ONLY" | "INTERNAL_AND_EXTERNAL" | "INTERNAL_ONLY";
export type UpdateAutoRecordRuleInput = {
  clientMutationId?: string | null;
  filterAttendeeType: FilterAttendeeType;
  filterKeywordsContains?: ReadonlyArray<string | null> | null;
  filterKeywordsRestrict?: ReadonlyArray<string | null> | null;
  filterMaximumAttendees?: number | null;
  filterMinimumAttendees?: number | null;
  filterOrganizer: AutoRecordRuleFilterOrganizer;
  id: string;
  ruleLevel: AutoRecordRuleLevel;
  ruleType: AutoRecordRuleType;
  usersWithReports?: ReadonlyArray<string> | null;
  usersWithoutReports?: ReadonlyArray<string> | null;
};
export type CreateAndEditModalUpdateRuleMutation$variables = {
  input: UpdateAutoRecordRuleInput;
};
export type CreateAndEditModalUpdateRuleMutation$data = {
  readonly updateAutoRecordRule: {
    readonly rule: {
      readonly id: string;
    };
  } | null;
};
export type CreateAndEditModalUpdateRuleMutation = {
  response: CreateAndEditModalUpdateRuleMutation$data;
  variables: CreateAndEditModalUpdateRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAutoRecordRulePayload",
    "kind": "LinkedField",
    "name": "updateAutoRecordRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AutoRecordRule",
        "kind": "LinkedField",
        "name": "rule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateAndEditModalUpdateRuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateAndEditModalUpdateRuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "64bcb12dd7df6d9940f77a8fdab3c068",
    "id": null,
    "metadata": {},
    "name": "CreateAndEditModalUpdateRuleMutation",
    "operationKind": "mutation",
    "text": "mutation CreateAndEditModalUpdateRuleMutation(\n  $input: UpdateAutoRecordRuleInput!\n) {\n  updateAutoRecordRule(input: $input) {\n    rule {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2673a181304c7a42a606d3f057d6951a";

export default node;
